import React, { useState, useEffect } from 'react';
import { database } from '../../Firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';

const Reportnamuna8v = () => {
    const navigate = useNavigate();
    // State for filter selection
    const [selectedFilter, setSelectedFilter] = useState('mulmalak');
    const [isAdvanceSearch, setIsAdvanceSearch] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [records, setRecords] = useState([]);
    const [allRecords, setAllRecords] = useState([]);

    useEffect(() => {
        const recordsRef = ref(database, 'Grampanchayat/Gramniddhi/NewMilakhatRecords');

        const unsubscribe = onValue(recordsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const recordsArray = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                // Sort by propertyNo if possible, currently just using raw order
                setAllRecords(recordsArray);
                setRecords(recordsArray);
            } else {
                setAllRecords([]);
                setRecords([]);
            }
        });

        return () => unsubscribe();
    }, []);

    // Filter logic based on search text
    useEffect(() => {
        if (!searchText.trim()) {
            setRecords(allRecords);
        } else {
            const filtered = allRecords.filter(record =>
                (record.propertyNo && record.propertyNo.toString().includes(searchText)) ||
                (record.mainOwner && record.mainOwner.toLowerCase().includes(searchText.toLowerCase()))
            );
            setRecords(filtered);
        }
    }, [searchText, allRecords]);


    return (
        <div className="min-h-screen bg-gray-100 p-4">
            <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden border border-gray-200">
                {/* Header Section */}
                <div className="bg-[#267c77] text-white px-4 py-3 flex justify-between items-center">
                    <h1 className="text-lg font-medium">नमुना नं. 8 व्यक्तीगत</h1>
                    <button
                        onClick={() => navigate('/report')}
                        className="bg-white text-[#267c77] px-4 py-1 rounded text-sm font-bold hover:bg-gray-100 transition-colors"
                    >
                        मागे (Back)
                    </button>
                </div>

                {/* Filter Section (Radio Buttons) */}
                <div className="bg-[#267c77] text-white px-4 py-2 border-t border-white/20">
                    <div className="flex items-center space-x-6 text-sm">
                        <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                                type="radio"
                                name="searchFilter"
                                value="mulmalak"
                                checked={selectedFilter === 'mulmalak'}
                                onChange={(e) => setSelectedFilter(e.target.value)}
                                className="text-[#267c77] focus:ring-0"
                            />
                            <span>मुळमालक</span>
                        </label>
                        <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                                type="radio"
                                name="searchFilter"
                                value="sanyukt"
                                checked={selectedFilter === 'sanyukt'}
                                onChange={(e) => setSelectedFilter(e.target.value)}
                                className="text-[#267c77] focus:ring-0"
                            />
                            <span>सयुंक्त मालक</span>
                        </label>
                        <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                                type="radio"
                                name="searchFilter"
                                value="propertyNo"
                                checked={selectedFilter === 'propertyNo'}
                                onChange={(e) => setSelectedFilter(e.target.value)}
                                className="text-[#267c77] focus:ring-0"
                            />
                            <span>मिळकत नं.</span>
                        </label>
                        <label className="flex items-center space-x-2 cursor-pointer">
                            <input
                                type="radio"
                                name="searchFilter"
                                value="occupier"
                                checked={selectedFilter === 'occupier'}
                                onChange={(e) => setSelectedFilter(e.target.value)}
                                className="text-[#267c77] focus:ring-0"
                            />
                            <span>भोगवाटाधारक</span>
                        </label>
                    </div>
                </div>

                {/* Advance Search Checkbox Section */}
                <div className="bg-[#267c77] text-white px-4 py-2 border-t border-white/20">
                    <label className="flex items-center space-x-2 cursor-pointer text-sm">
                        <input
                            type="checkbox"
                            checked={isAdvanceSearch}
                            onChange={(e) => setIsAdvanceSearch(e.target.checked)}
                            className="rounded text-[#267c77] focus:ring-0"
                        />
                        <span>अधिक शोध (Advance Search)</span>
                    </label>
                </div>

                {/* Search Bar Section */}
                <div className="p-4 bg-white">
                    <div className="flex border border-gray-300 rounded overflow-hidden">
                        <input
                            type="text"
                            placeholder="शोधणे"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="flex-grow px-4 py-2 outline-none text-gray-700"
                        />
                        <button className="bg-[#28a745] text-white px-6 py-2 font-medium hover:bg-green-700 transition-colors">
                            शोधणे
                        </button>
                    </div>
                </div>

                {/* Table Section */}
                <div className="px-4 pb-4">
                    <div className="overflow-x-auto border border-gray-300 rounded-t-lg">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-[#267c77] text-white">
                                    <th className="py-2 px-4 border-r border-[#1f6360] text-left font-medium w-32">मिळकत नं.</th>
                                    <th className="py-2 px-4 border-r border-[#1f6360] text-left font-medium">मुळ मालकाचे नाव</th>
                                    <th className="py-2 px-4 border-r border-[#1f6360] text-left font-medium w-48">मिळकत प्रकार</th>
                                    <th className="py-2 px-4 text-center font-medium w-32">पर्याय</th>
                                </tr>
                            </thead>
                            <tbody>
                                {records.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="text-center py-4 text-gray-500">No records found</td>
                                    </tr>
                                ) : (
                                    records.map((row) => (
                                        <tr key={row.id} className="border-b border-gray-300 hover:bg-gray-50">
                                            <td className="py-2 px-4 border-r border-gray-300 text-center">{row.propertyNo}</td>
                                            <td className="py-2 px-4 border-r border-gray-300">{row.mainOwner}</td>
                                            <td className="py-2 px-4 border-r border-gray-300">
                                                {row.propertyRecords && row.propertyRecords.length > 0
                                                    ? row.propertyRecords[0].propertyType
                                                    : 'N/A'}
                                            </td>
                                            <td className="py-2 px-4 text-center">
                                                <button
                                                    onClick={() => window.open(`/namuna8/${row.id}`, '_blank')}
                                                    className="flex items-center justify-center space-x-1 bg-[#267c77] text-white px-2 py-1 rounded text-xs hover:bg-[#1f6360]"
                                                >
                                                    {/* File Icon SVG */}
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                    </svg>
                                                    <span>नमुना ८</span>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="bg-[#267c77] text-white p-2 flex justify-center items-center space-x-1 text-sm rounded-b-lg">
                        <button className="px-2 py-1 hover:bg-[#1f6360] flex items-center">
                            <span className="mr-1">|&lt;</span>
                        </button>
                        <button className="px-2 py-1 hover:bg-[#1f6360] flex items-center">
                            <span className="mr-1">&lt;</span>
                        </button>
                        <button className="px-3 py-1 bg-white text-[#267c77] font-bold border border-white rounded mx-1">
                            1
                        </button>
                        <button className="px-2 py-1 hover:bg-[#1f6360] flex items-center">
                            <span className="mr-1">&gt;</span>
                        </button>
                        <button className="px-2 py-1 hover:bg-[#1f6360] flex items-center">
                            <span className="mr-1">&gt;|</span>
                        </button>
                        <div className="ml-4 flex items-center">
                            <span>5</span>
                            <span className="ml-1">▼</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reportnamuna8v;
